import { SET_ERROR, CLEAR_ERROR } from 'app/redux/constants';

export const setError = payload => ({ payload, type: SET_ERROR });
export const clearError = () => ({ type: CLEAR_ERROR });



// WEBPACK FOOTER //
// ./src/redux/actions/error.js